const REGEX_DOC_FORMAT = /\D/g;

const formatNumber = (input, decimalPlaces) => {
    if (!input) return '0';
    input = parseFloat(input);
    return input.toLocaleString('pt-BR', {
        maximumFractionDigits: decimalPlaces,
        minimumFractionDigits: decimalPlaces
    });
};

const maxFormatNumber = (input, decimalPlaces) => {
    if (!input) return '-';
    input = parseFloat(input);
    return input.toLocaleString('pt-BR', {
        maximumFractionDigits: decimalPlaces
    });
};

const minFormatNumber = (input, decimalPlaces, locale) => {
    if (input == null || input === '') return '-';
    let formattedInput = input;

    if (typeof input === 'string') {
        formattedInput = input
            .trim()
            .replace(/\./g, '')
            .replace(',', '.');
    }

    input = parseFloat(formattedInput);
    return input.toLocaleString(locale, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    });
};

const formatNumberUs = (input, decimalPlaces) => {
    if (!input) {
        return '0';
    }

    const inputString = String(input);
    if (inputString.includes('.')) {
        let n = inputString.split('.', decimalPlaces);
        if (n.length > 1) {
            input =
                n[0] +
                '.' +
                n[1]
                    .substr(0, n[1].length - (n[1].length - decimalPlaces))
                    .padEnd(decimalPlaces, '0');
        } else {
            input = n[0];
        }
    }
    const options = {
        style: 'decimal',
        currency: 'BRL'
    };
    const formatNumber = new Intl.NumberFormat('en-US', options);
    return formatNumber.format(input).replace(/,/g, '.');
};

const formatProdutividade = produtividade => {

    if (!produtividade) return null;

    const options = {
        style: 'decimal',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    };

    const formatNumber = new Intl.NumberFormat('pt-BR', options);
    const resultado = Number.parseFloat(produtividade);

    if (resultado === 0) {
        return '-';
    }

    const variacao = 0.05; // 5%

    return `${formatNumber.format(
        resultado - resultado * variacao
    )} a ${formatNumber.format(resultado + resultado * variacao)}`;
};

const documentoFormatToNumeral = documento => {
    const value = documento.replace(REGEX_DOC_FORMAT, '');
    if (
        value &&
        (value.length === 11 || value.length === 14 || value.length === 8 || value.length === 9) &&
        Number(value)
    ) {
        return value;
    }

    return documento;
};

const numeralStringFormatToDocumento = (numeralString, tipoDocumento) => {
    if (!numeralString) return '';

    if (tipoDocumento && ['CUIT', 'DNI', 'CUIT/DNI'].includes(tipoDocumento.toUpperCase())) {
        const clean = String(numeralString).replace(/\D/g, '');
        return clean.length === 11 ? mascaraCUIT(clean) : clean;
    }

    if (numeralString.includes('X')) {
        numeralString = removerPontuacaoDocumentoLgpd(numeralString);
    }

    if (numeralString.length === 11) {
        if (numeralString.includes('X')) {
            return mascaraCpfLgpd(numeralString);
        } else {
            return mascaraCpf(numeralString);
        }
    } else if (numeralString.length === 14) {
        return mascaraCnpj(numeralString);
    } else if (numeralString.length === 8 || numeralString.length === 9) {
        return mascaraRuc(numeralString);
    } else {
        return numeralString;
    }
};

function mascaraCpf(valor) {
    return valor
        .replace(/[^\w\s]/gi, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/^(-\d{2})(\d)$/, '$1');
}

function mascaraCpfLgpd(valor) {
    return valor.substring(0, 3) + '.' + valor.substring(3, 6) + '.' + valor.substring(6, 9) + '-' + valor.substring(9, 11);
}

function mascaraCnpj(valor) {
    return valor
        .replace(/[^\w\s]/gi, '')
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .replace(/^(-\d{2})(\d)?/, '$1');
}

function mascaraRuc(valor) {
    const string = valor.replace(/[^\w\s]/gi, '');

    const partes = [
        string.substring(0, string.length - 1),
        string.substring(string.length - 1, string.length)
    ];

    return partes.join('-');
}

function mascaraCUIT(valor) {
  const clean = valor.replace(/\D/g, '');
  // 2 dígitos + 8 dígitos + 1 dígito verificador
  return clean.replace(/^(\d{2})(\d{8})(\d)$/, '$1-$2-$3');
}

function utf8Decode(utf8String) {
    // eslint-disable-next-line eqeqeq
    if (typeof utf8String != 'string') {
        throw new TypeError('parameter ‘utf8String’ is not a string');
    }
    const unicodeString = utf8String
        .replace(
            /[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g,
            function (c) {
                var cc =
                    ((c.charCodeAt(0) & 0x0f) << 12) |
                    ((c.charCodeAt(1) & 0x3f) << 6) |
                    (c.charCodeAt(2) & 0x3f);
                return String.fromCharCode(cc);
            }
        )
        .replace(/[\u00c0-\u00df][\u0080-\u00bf]/g, function (c) {
            var cc = ((c.charCodeAt(0) & 0x1f) << 6) | (c.charCodeAt(1) & 0x3f);
            return String.fromCharCode(cc);
        });
    return unicodeString;
}

function formatCar(valor) {
    if (!valor) return;
    return valor
        .replace(/[^\w\s]/gi, '')
        .replace(/(\w{2})(\w)/, '$1-$2')
        .replace(/(\w{7})(\w)/, '$1-$2')
        .replace(/(-\w{32})(\w)?/, '$1')
        .replace(/ /g, '')
        .toUpperCase();
}

function formatCodigoParcela(valor) {
    if (!valor) return;

    const string = valor.replace(/[^\w\s]/gi, '');

    const partes = [
        string.substring(0, 8),
        string.substring(8, 12),
        string.substring(12, 16),
        string.substring(16, 20),
        string.substring(20)
    ];
    return partes.join('-');
}

function formatCarEstadualMT(valor) {
    if (!valor) return;

    const string = valor.replace(/[^\w\s]/gi, '');

    const ano = string.length - 4;
    const partes = [
        string.substring(0, ano),
        string.substring(ano, string.length)
    ];
    return partes.join('/');
}

const numeralToCompactMonth = function (numeral) {
    numeral -= 1;

    const compactMonths = [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez'
    ];

    return compactMonths[numeral];
};

const dateStringToDayName = function (dateString) {
    const days = [
        'Domingo',
        'Segunda',
        'Terça',
        'Quarta',
        'Quinta',
        'Sexta',
        'Sábado'
    ];
    const date = new Date(dateString);
    date.setDate(date.getDate() + 1);
    return days[date.getDay()];
};

function converterDataFullParaDataBR(data) {
    if (!data || data === null || data === undefined) {
        return '- -';
    }
    const dataObjeto = new Date(data);
    const dia = String(dataObjeto.getDate()).padStart(2, '0');
    const mes = String(dataObjeto.getMonth() + 1).padStart(2, '0');
    const ano = dataObjeto.getFullYear();
    return `${dia}/${mes}/${ano}`;
}

function reduzirCar(car) {
    if (typeof car !== 'string') return;
    if (car.length < 14) return;

    return car.slice(0, 9) + '...' + car.slice(car.length - 4);
}

function formatarCEP(cep) {
    let cep_ = cep.replace(/\D/g, '');

    if (cep_.length !== 8) {
        return cep_;
    }

    return cep_.substring(0, 5) + '-' + cep_.substring(5);
}

function isEmpty(data) {
    if (data === undefined || data === '' || data === null) {
        return '- -';
    } else {
        return data;
    }
}

function removerPontuacaoDocumento(input) {
    if (input) {
        return input.replace(/[^\d]+/g, '');
    }

    return input;
}

function removerPontuacaoDocumentoLgpd(input) {
    if (input) {
        return input.replaceAll('.', '').replace('-', '').replace('/', '');
    }

    return input;
}

const numeralStringFormatTocpfCnpj = numeralString => {
    if (!numeralString) return '';

    if (numeralString.length === 11) {
        return mascaraCpf(numeralString);
    } else if (numeralString.length === 14) {
        return mascaraCnpj(numeralString);
    } else if (numeralString.length === 8 || numeralString.length === 9) {
        return mascaraRuc(numeralString);
    } else {
        return numeralString;
    }
};

function formatIntegerTwoDigits(input) {
    if (input <= 9) return '0' + input;
    return input;
}

function formatDateToISO(data) {
    if (!data) return null;
    const d = new Date(data);
    if (isNaN(d.getTime())) return null;
    const ano = d.getFullYear();
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const dia = String(d.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
}

function localDateTimeToString(input) {
    const date = new Date(
        input.year,
        input.monthValue - 1,
        input.dayOfMonth,
        input.hour,
        input.minute,
        input.second
    );

    return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });
}

function localDateToString(input) {
    if (!input || input.year == null || input.monthValue == null || input.dayOfMonth == null) return null;
    const day = String(input.dayOfMonth).padStart(2, '0');
    const month = String(input.monthValue).padStart(2, '0');
    return `${day}/${month}/${input.year}`;
}

function localDateToISO(input) {
    if (!input || input.year == null || input.monthValue == null || input.dayOfMonth == null) return null;
    const day = String(input.dayOfMonth).padStart(2, '0');
    const month = String(input.monthValue).padStart(2, '0');
    return `${input.year}-${month}-${day}`;
}

export default {
    formatNumber,
    maxFormatNumber,
    minFormatNumber,
    formatNumberUs,
    formatProdutividade,
    documentoFormatToNumeral,
    numeralStringFormatToDocumento,
    utf8Decode,
    formatCar,
    formatCodigoParcela,
    formatCarEstadualMT,
    numeralToCompactMonth,
    dateStringToDayName,
    converterDataFullParaDataBR,
    reduzirCar,
    formatarCEP,
    isEmpty,
    removerPontuacaoDocumento,
    removerPontuacaoDocumentoLgpd,
    numeralStringFormatTocpfCnpj,
    formatIntegerTwoDigits,
    formatDateToISO,
    localDateTimeToString,
    localDateToString,
    localDateToISO
};
